export default "__VITE_ASSET__DYZ3JZLl__"